import { render, staticRenderFns } from "./H5Page.vue?vue&type=template&id=e0721c22&scoped=true"
import script from "./H5Page.vue?vue&type=script&lang=js"
export * from "./H5Page.vue?vue&type=script&lang=js"
import style0 from "./H5Page.vue?vue&type=style&index=0&id=e0721c22&prod&scoped=true&lang=css"
import style1 from "./H5Page.vue?vue&type=style&index=1&id=e0721c22&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0721c22",
  null
  
)

export default component.exports